import * as Sentry from '@sentry/gatsby';

if (process.env.GATSBY_EH_ENV === 'prod') {
    Sentry.init({
        dsn: 'https://d5123a0c141510bfa6ac69244570951d@o978409.ingest.us.sentry.io/4506940247965696',
        environment: process.env.GATSBY_EH_ENV,
        integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
        // Performance Monitoring
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
        // Session Replay
        replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        ignoreErrors: [/.*Minified React error #.*/, /.*tealium.*/, /.*\[alloy\].*/],
    });
} else {
    if (typeof window !== 'undefined') {
        const SentryMock = {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            addBreadcrumb: (crumb: any) => {
                const level: string = crumb ? crumb.level : null;
                if (/info/i.test(level)) {
                    console.info(crumb);
                } else if (/warn/i.test(level)) {
                    console.warn(crumb);
                } else if (/error/i.test(level)) {
                    console.error(crumb);
                } else {
                    console.log(crumb);
                }
            },
            captureEvent: () => console.log('mocking Sentry captureEvent fn'),
            captureException: () => console.log('mocking Sentry captureException fn'),
            captureMessage: () => console.log('mocking Sentry captureMessage fn'),
            configureScope: () => console.log('mocking Sentry configureScope fn'),
            forceLoad: () => console.log('mocking Sentry forceLoad fn'),
            init: () => console.log('mocking Sentry init fn'),
            onLoad: () => console.log('mocking Sentry onLoad fn'),
            showReportDialog: () => console.log('mocking Sentry showReportDialog fn'),
            withScope: () => console.log('mocking Sentry withScope fn'),
        };

        Object.defineProperty(window, 'Sentry', {
            writable: false,
            value: SentryMock,
        });
    }
}
